import React from "react";
import {
  IconAlarm,
  IconBoxDevice,
  IconBoxInfo,
  IconDateRange,
  IconPigSaving,
} from "../../components/Icons/Icons";
import { formatCurrencyCOP } from "../../helpers/FormatNumber";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";

export const PageMyInvestmentClose = ({ data }) => {
  // TODO datos REALES
  const chartData = [
    { year: "2020", compra: -400000, rendimientos: 150000, ventas: 100000 },
    { year: "2021", compra: -450000, rendimientos: 180000, ventas: 120000 },
    { year: "2022", compra: -480000, rendimientos: 200000, ventas: 150000 },
    { year: "2023", compra: -500000, rendimientos: 220000, ventas: 180000 },
    { year: "2024", compra: -550000, rendimientos: 250000, ventas: 200000 },
  ].map((item) => ({
    ...item,
    total: item.compra + item.rendimientos + item.ventas,
  }));  

  console.log(data);

  return (
    <div className="container-fluid">
      <div className="d-flex row justify-content-around">
        {/* Columna 1: Detalle inversión */}
        <div className="col col-xs-12">
          <div className="d-flex align-items-center mb-3 investment-detail-title">
            <IconBoxInfo
              style={{ transform: "translate(0px, 5px)" }}
              colorIcon={"#1b4ec1"}
              height={"20px"}
              width={"20px"}
            />
            <p>Detalle de la inversión</p>
          </div>

          <div className="d-flex mt-2">
            <div className="icon-box me-2">
              <IconPigSaving style={{ transform: "translate(0px, 4px)" }} />
            </div>
            <div className="d-flex flex-column detail-item">
              <h3 className="fw-bold">Rendimientos acumulados</h3>
              <div>{data.rendimientos ?? "0"}</div>
            </div>
          </div>

          <div className="d-flex mt-2">
            <div className="icon-box me-2">
              <IconBoxDevice height={"20px"} width={"20px"} />
            </div>
            <div className="d-flex flex-column detail-item">
              <h3 className="fw-bold">Unidades disponibles</h3>
              <div>{data.unidades ?? "0"}</div>
            </div>
          </div>

          <div className="d-flex mt-2">
            <div className="icon-box me-2">
              <IconAlarm style={{ transform: "translate(0px, 4px)" }} />
            </div>
            <div className="d-flex flex-column detail-item">
              <h3 className="fw-bold">Estado de la inversión</h3>
              <div>{data.status}</div>
            </div>
          </div>

          <div className="d-flex mt-2">
            <div className="icon-box me-2">
              <IconDateRange style={{ transform: "translate(0px, 4px)" }} />
            </div>
            <div className="d-flex flex-column detail-item">
              <h3 className="fw-bold">Fecha de solicitud</h3>
              <div>{data.created_at}</div>
            </div>
          </div>
        </div>

        {/* Columna 2: Valor actual */}
        <div className="col col-xs-12">
          <div className="containerAdmonInfo">
            <div className="d-flex align-items-center gap-3">
              <img
                src={data.fondoInfo.imagen}
                alt={data.fondoInfo.name}
                className="rounded"
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                  backgroundColor: "#F5F1EB",
                  marginRight: "10px",
                }}
              />
              <div>
                <h4>Valor actual</h4>
                <p className="mb-1">
                  Tienes {data.unidades ?? 0} unidades disponibles
                </p>
                <p className="mb-0">
                  equivalen a {formatCurrencyCOP(data.invested_amount)} COP
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Columna 3: Gráfica */}
        <div className="col-6 col-xs-12">
          <div className="card shadow-sm">
            <div className="card-body">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={chartData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="year" />
                  <YAxis
                    tickFormatter={(v) => formatCurrencyCOP(v)}
                    domain={["dataMin", "dataMax"]}
                    allowDecimals={false}
                  />

                  <Tooltip formatter={(v) => formatCurrencyCOP(v)} />
                  <Legend />
                  <Bar
                    dataKey="compra"
                    stackId="a"
                    fill="#dc3545"
                    name="Compra"
                  />
                  <Bar
                    dataKey="rendimientos"
                    stackId="a"
                    fill="#28a745"
                    name="Rendimientos"
                  />
                  <Bar
                    dataKey="ventas"
                    stackId="a"
                    fill="#28a745"
                    name="Ventas"
                  />
                  <Bar dataKey="total" fill="#ffc107" name="Total" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
